// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jJp8_","delete":"styles_delete__2L8dV","update":"styles_update__1xxSr","add":"styles_add__3Ivbx"};